import React, { useState, useEffect } from 'react';
import { useAccount } from '../assets/js/ContextProviders/AccountContext';
import ReviewStars from './ReviewStars';
import { handleSubmit } from '../apis/dataService';
import ReviewIMG from '../Images/GoogleDrive_640X469_10-Powerful-Things-You-Can-Do-with-Review-Intelligence-02-1280x992.png';
// import axios from 'axios';

export default function ReviewForm() {
    const { GetUsername } = useAccount();
    const [review, setReview] = useState('');
    const [selectedStars, setSelectedStars] = useState(0);

    const handleReviewChange = (event) => {
        setReview(event.target.value);
    };

    const handleformSubmit = (event) => {
        if (selectedStars && review) {
            handleSubmit({
                username: GetUsername(),
                api: 'reviews-form',
                h1: 'Review',
                data1: review,
                h2: 'RatingStars',
                data2: selectedStars
            })
            const ReviewFormShadow = document.querySelector('.Review-ThanksforReview');
            const ReviewForm = document.querySelector('.ReviewForm');
            const ReviewFormParent = document.querySelector('.ReviewForm-parent');
            if (ReviewFormShadow) {
                ReviewFormShadow.style.display = 'flex';
                setTimeout(() => {
                    ReviewFormShadow.classList.add('opacity-transtion-1')
                }, [100])
                setTimeout(() => {
                    ReviewForm.classList.add('opacity-transition-0')
                }, [600])
                setTimeout(() => {
                    ReviewFormParent.classList.add('height-transition-0')
                }, [900])
            }
            setReview('')
        } else if (!review) {
            const textarea = document.querySelector('.review-textarea')
            if (textarea) {
                textarea.focus()
            }
        }
        else if (!selectedStars) {
            const ReviewStars = document.querySelector('.ReviewStars')
            if (ReviewStars) {
                ReviewStars.classList.add('ReviewStars-scaled')
                setTimeout(() => {
                    ReviewStars.classList.remove('ReviewStars-scaled')
                }, [300])
            }
        }
    }

    const handleStarChange = (selectedStarsNo) => {
        setSelectedStars(selectedStarsNo);
    };


    return (
        <>
            <div className="Review-img">
                <img src={ReviewIMG} alt="" />
            </div>
            <div className='ReviewForm'>
                <h1>
                    Add Your Review
                </h1>
                <form>
                    <div className="reviewform-cell">
                        <div className="reviewform-cell-heading">Username:</div>
                        <div className="reviewform-cell-div">{GetUsername()}</div>
                    </div>
                    <div className="reviewform-cell">
                        <label className="reviewform-cell-heading">Review:</label>
                        <ReviewStars onStarChange={handleStarChange} />
                        <textarea
                            value={review}
                            placeholder="Enter your Review..."
                            required
                            onChange={handleReviewChange}
                            className="review-textarea"
                        />
                    </div>
                    <div className="reviewform-submit flex">
                        <div className="Review-submit-btn flex" onClick={handleformSubmit}>
                            SUBMIT
                        </div>
                    </div>
                </form>
                <div className="Review-ThanksforReview">
                    THANKS FOR REVIEW
                </div>
            </div>

        </>
    )
}